/**
 * Removes properties with null values and empty strings from the given object.
 *
 * @param {T} obj - The object from which null value properties and empty strings should be removed.
 * @return {{ [p: string]: any }} A new object without properties that have null values or empty strings.
 */
export function removeNullValues<T extends Record<string, any>>(obj: T): { [p: string]: any } {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => value !== null && value !== '')
  );
}
